const configuredBaseUrl = import.meta.env.VITE_API_BASE_URL?.trim() ?? "";
const apiOrigin = configuredBaseUrl.replace(/\/$/, "");

export class ApiError extends Error {
  constructor(message: string, public status: number) {
    super(message);
  }
}

export async function apiRequest<T>(path: string, init: RequestInit = {}): Promise<T> {
  if (!apiOrigin) throw new Error("VITE_API_BASE_URL is not configured");
  const headers = new Headers(init.headers);
  if (init.body && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  const response = await fetch(`${apiOrigin}${path.startsWith("/") ? path : `/${path}`}`, {
    ...init,
    headers,
    credentials: "include",
  });
  const contentType = response.headers.get("content-type") ?? "";
  const body = contentType.includes("application/json") ? await response.json() : await response.text();
  if (!response.ok) {
    const message = typeof body === "object" && body && "message" in body
      ? String(body.message)
      : `Request failed (${response.status})`;
    throw new ApiError(message, response.status);
  }
  return body as T;
}

export const keys = {
  session: ["security", "session"] as const,
  overview: ["security", "overview"] as const,
  ntfy: ["security", "notifications", "ntfy"] as const,
  events: (filters: unknown) => ["security", "events", filters] as const,
  blocked: (filters: unknown) => ["security", "blocked", filters] as const,
};
